import { useMemo } from 'react';

import { defaultGameSizesConfig } from '../GameItem';
import { defaultGridOptions, defaultPerChunk, GridDimensions } from './helpers';
import { MediaType } from '@/helpers/enums';
import { useCurrentMediaType } from '@/hooks/responsive';

export const useGridDimensions = ({
  perChunkObj = defaultPerChunk,
  gridOptions = defaultGridOptions,
  gameSizesConfig = defaultGameSizesConfig,
}: GridDimensions) => {
  const currentMediaType = useCurrentMediaType();

  const { perChunk, gridColumns, gameSize } = useMemo(() => {
    switch (currentMediaType) {
      case MediaType.DESKTOP_L:
        return {
          perChunk: perChunkObj.desktopL,
          gridColumns: gridOptions.columns,
          gameSize: gameSizesConfig?.desktopL,
        };
      case MediaType.DESKTOP:
        return {
          perChunk: perChunkObj.desktop,
          gridColumns: gridOptions.columns,
          gameSize: gameSizesConfig?.desktop,
        };
      case MediaType.TABLET:
        return {
          perChunk: perChunkObj.tablet,
          gridColumns: gridOptions.columnsTablet,
          gameSize: gameSizesConfig?.tablet,
        };
      case MediaType.MOBILE:
        return {
          perChunk: perChunkObj.mobile,
          gridColumns: gridOptions.columnsMobile,
          gameSize: gameSizesConfig?.mobile,
        };
      case MediaType.MOBILE_S:
      default:
        return {
          perChunk: perChunkObj.mobileS,
          gridColumns: gridOptions.columnsMobileS,
          gameSize: gameSizesConfig?.mobileS,
        };
    }
  }, [currentMediaType, perChunkObj, gridOptions, gameSizesConfig]);

  return { perChunk, gridColumns, gameSize };
};
